import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { createQueryCustomHook } from "../../../../stores/useQueryState";
import { Select } from "../../../../ui/Select/Select";
import { Label } from "../Label/Label";
import { OrderDateOption, orderDateOptions } from "./orderDateOptions";

export const useOrdersDateParam = createQueryCustomHook("date", () => {
  return (value): OrderDateOption => {
    return orderDateOptions.includes(value as OrderDateOption)
      ? (value as OrderDateOption)
      : orderDateOptions[0];
  };
});

export const OrdersDateSelect: FunctionComponent = () => {
  const { t } = useTranslation();
  const [value, setValue] = useOrdersDateParam();
  return (
    <fieldset>
      <Label htmlFor="date-filter">{t("orderFilters.show")}</Label>
      <Select
        onChange={(event): void => {
          setValue(event.target.value as OrderDateOption);
        }}
        aria-label="dateFilter"
        className="w-full"
        id="date-filter"
        value={value}
      >
        {orderDateOptions.map((option) => (
          <option key={option} value={option}>
            {t(`orderFilters.${option}`)}
          </option>
        ))}
      </Select>
    </fieldset>
  );
};
